import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=dd5132a4&scoped=true"
import script from "./Draggable.vue?vue&type=script&lang=ts"
export * from "./Draggable.vue?vue&type=script&lang=ts"
import style0 from "./Draggable.vue?vue&type=style&index=0&id=dd5132a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5132a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd5132a4')) {
      api.createRecord('dd5132a4', component.options)
    } else {
      api.reload('dd5132a4', component.options)
    }
    module.hot.accept("./Draggable.vue?vue&type=template&id=dd5132a4&scoped=true", function () {
      api.rerender('dd5132a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/Draggable.vue"
export default component.exports